import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';
import { RoleGuard } from './core/auth/guards/role.guard';
import { Customerror403Component } from './modules/admin/pages/error/customerror403/customerror403.component';
import { UserRole } from 'app/core/roles/roles.model';
import { TransactionGuard } from './core/auth/guards/transaction.guard';
import { PaymentSytemsByMerchantComponent } from './modules/admin/paymentsystem-configurations/payment-sytems-by-merchant/payment-sytems-by-merchant.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'sign-in' },

    // Redirect signed in user to the '/example'
    //
    // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    // { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'example' },

    // Auth routes for guests
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            // {
            //     path: 'confirmation-required',
            //     loadChildren: () =>
            //         import(
            //             'app/modules/auth/confirmation-required/confirmation-required.module'
            //         ).then((m) => m.AuthConfirmationRequiredModule),
            // },
            // {
            //     path: 'forgot-password',
            //     loadChildren: () =>
            //         import(
            //             'app/modules/auth/forgot-password/forgot-password.module'
            //         ).then((m) => m.AuthForgotPasswordModule),
            // },
            // {
            //     path: 'reset-password',
            //     loadChildren: () =>
            //         import(
            //             'app/modules/auth/reset-password/reset-password.module'
            //         ).then((m) => m.AuthResetPasswordModule),
            // },
            {
                path: 'sign-in',
                loadChildren: () =>
                    import('app/modules/auth/sign-in/sign-in.module').then(
                        (m) => m.AuthSignInModule,
                    ),
            },

            // {
            //     path: 'sign-up',
            //     loadChildren: () =>
            //         import('app/modules/auth/sign-up/sign-up.module').then(
            //             (m) => m.AuthSignUpModule
            //         ),
            // },
        ],
    },

    // Auth routes for authenticated users
    // {
    //     path: '',
    //     canActivate: [AuthGuard],
    //     canActivateChild: [AuthGuard],
    //     component: LayoutComponent,
    //     data: {
    //         layout: 'empty',
    //     },
    //     children: [
    //         {
    //             path: 'sign-out',
    //             loadChildren: () =>
    //                 import('app/modules/auth/sign-out/sign-out.module').then(
    //                     (m) => m.AuthSignOutModule
    //                 ),
    //         },
    //         {
    //             path: 'unlock-session',
    //             loadChildren: () =>
    //                 import(
    //                     'app/modules/auth/unlock-session/unlock-session.module'
    //                 ).then((m) => m.AuthUnlockSessionModule),
    //         },
    //     ],
    // },

    // Landing routes
    // {
    //     path: '',
    //     component: LayoutComponent,
    //     data: {
    //         layout: 'empty',
    //     },
    //     children: [
    //         {
    //             path: 'home',
    //             loadChildren: () =>
    //                 import('app/modules/landing/home/home.module').then(
    //                     (m) => m.LandingHomeModule
    //                 ),
    //         },
    //     ],
    // },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        // canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'dashboards',
                children: [
                    {
                        path: 'finance',
                        loadChildren: () =>
                            import('app/modules/admin/finance/finance.module').then(
                                (m) => m.FinanceModule,
                            ),
                    },
                ],
            },
            {
                path: 'tables',
                children: [
                    // {
                    //     path: 'cashforo-table',
                    //     loadChildren: () =>
                    //         import(
                    //             'app/modules/admin/cashforo-table/cashforo-table.module'
                    //         ).then((m) => m.CashforoTableModule),
                    // },
                    {
                        path: 'cashforo-withdraw',
                        canActivate: [RoleGuard],
                        data: {
                            roles: [
                                UserRole.Admin,
                                UserRole.SuperUser,
                                UserRole.MerchantAdmin,
                                UserRole.Support,
                            ],
                        },
                        loadChildren: () =>
                            import('app/modules/admin/withdraw-table/withdraw-table.module').then(
                                (m) => m.WithdrawTableModule,
                            ),
                    },
                    {
                        path: 'cashforo-withdraw-v2',
                        canActivate: [RoleGuard],
                        data: {
                            roles: [
                                UserRole.Admin,
                                UserRole.SuperUser,
                                UserRole.MerchantAdmin,
                                UserRole.Support,
                                UserRole.Viewer,
                            ],
                        },
                        loadChildren: () =>
                            import('app/modules/admin/withdraw-table-v2/withdraw-table-v2.module').then(
                                (m) => m.WithdrawTableV2Module,
                            ),
                    },
                    {
                        path: 'cashforo-table-v2',
                        data: {
                            roles: [
                                UserRole.Admin,
                                UserRole.SuperUser,
                                UserRole.MerchantAdmin,
                                UserRole.Support,
                                UserRole.Viewer,
                            ],
                        },
                        loadChildren: () =>
                            import('app/modules/admin/cashforo-table-v2/cashforo-table-v2.module').then(
                                (m) => m.CashforoTableV2Module,
                            ),
                    },
                    {
                        path: 'user-table',
                        canActivate: [RoleGuard],
                        data: {
                            roles: [UserRole.SuperUser, UserRole.MerchantAdmin],
                        },
                        loadChildren: () =>
                            import('app/modules/admin/user-table/user-table.module').then(
                                (m) => m.UserTableModule,
                            ),
                    },
                    {
                        path: 'merchant-table',
                        canActivate: [RoleGuard],
                        data: { roles: [UserRole.SuperUser] },
                        loadChildren: () =>
                            import('app/modules/admin/merchant-table/merchant-table.module').then(
                                (m) => m.MerchantTableModule,
                            ),
                    },
                    {
                        path: 'roles-table',
                        canActivate: [RoleGuard],
                        data: { roles: [UserRole.SuperUser] },
                        loadChildren: () =>
                            import('app/modules/admin/roles-table/roles-table.module').then(
                                (m) => m.RolesTableModule,
                            ),
                    },
                    {
                        path: 'paymentsystem-configurations',
                        canActivate: [RoleGuard],
                        data: { roles: [UserRole.SuperUser] },
                        loadChildren: () =>
                            import('app/modules/admin/paymentsystem-configurations/paymentsystem-configurations.module').then(
                                (m) => m.PaymentsystemConfigurationsModule,
                            ),
                    },
                    {
                        path: 'payment-system-tags',
                        canActivate: [RoleGuard],
                        data: { roles: [UserRole.SuperUser] },
                        loadChildren: () =>
                            import('app/modules/admin/payment-system-tags/payment-system-tags.module').then(
                                (m) => m.PaymentSystemTagsModule,
                            ),
                    },
                    {
                        path: 'withdraw-limits',
                        canActivate: [RoleGuard],
                        data: {
                            roles: [UserRole.SuperUser, UserRole.MerchantAdmin],
                        },
                        loadChildren: () =>
                            import('app/modules/admin/withdraw-limits/withdraw-limits.module').then(
                                (m) => m.WithdrawLimitsModule,
                            ),
                    },
                    {
                        path: 'payment-system-balances',
                        canActivate: [RoleGuard],
                        data: {
                            roles: [UserRole.SuperUser, UserRole.Support],
                        },
                        loadChildren: () =>
                            import('app/modules/admin/payment-system-balances/payment-system-balances.module').then(
                                (m) => m.PaymentSystemBalancesModule,
                            ),
                    },
                    {
                        path: 'verification',
                        canActivate: [RoleGuard],
                        data: { roles: [UserRole.SuperUser, UserRole.Support] },
                        loadChildren: () =>
                            import('app/modules/admin/verification/verification.module').then(
                                (m) => m.VerificationModule,
                            ),
                    },
                ],
            },
        ],
    },
    // Creditcard form
    {
        path: 'creditcard',
        canActivate: [TransactionGuard],
        pathMatch: 'full',
        loadChildren: () =>
            import('app/modules/admin/pages/form/creditcard-form/creditcard-form.module').then(
                (m) => m.CreditcardFormModule,
            ),
    },

    {
        path: 'cashforo-withdraw-v2',
        loadChildren: () =>
            import('app/modules/admin/withdraw-table-v2/withdraw-table-v2.module').then(
                (m) => m.WithdrawTableV2Module,
            ),
    },

    // Creditcard form paytently
    {
        path: 'creditcard-paytently',
        pathMatch: 'full',
        loadChildren: () =>
            import('app/modules/admin/pages/form/creditcard-form-paytently/creditcard-form-paytently.module').then(
                (m) => m.CreditcardFormModule,
            ),
    },

    // 404 & Catch all
    {
        path: '404-not-found',
        pathMatch: 'full',
        loadChildren: () =>
            import('app/modules/admin/pages/error/error-404/error-404.module').then(
                (m) => m.Error404Module,
            ),
    },
    {
        path: '403-something-happened',
        pathMatch: 'full',
        component: Customerror403Component,
    },
    { path: '**', redirectTo: '404-not-found' },
];
